import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';
import { getAbcatDetails } from '../../../../../../services/apiService';
// import { Visibility } from '@material-ui/icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

// const certiCharCount = 60;

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};
const pageSize = 10;
const getGoalType = (courseType) => {
  if (courseType === 'data-engineering') return 'dataEngineering';
  if (courseType === 'data-science' || courseType === 'dataScience')
    return 'data-science';
  if (courseType === 'web3') return 'web3';
  return null;
};

const AbcatDetails = ({ courseType, studentId }) => {
  const [rowData, setRowData] = useState(null);
  const history = useHistory();

  //   const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      if (courseType && studentId) {
        const response = await getAbcatDetails(
          getGoalType(courseType),
          studentId
        );

        setRowData(response?.data);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };
  const columnDefs = [
    {
      field: 'attempt',
      headerName: 'Attempt',
      cellRenderer: (params) => (
        <span
          className='text-blue-600 underline cursor-pointer'
          onClick={() => {
            const path = `/all-almax-students/user-details/${params.data.id}`;
            history.push({
              pathname: path,
              state: {
                userParams: params.data,
              },
            });
          }}
          title='View details'
        >
          {params.value}
        </span>
      ),
      sortable: true,
      filter: true,
    },
    { field: 'id', hide: true },

    { field: 'email', headerName: 'Email' },
    { field: 'status', headerName: 'DoSelect Status' },
    {
      field: 'progress',
      headerName: 'Progress',
    },
    { field: 'test_name', headerName: 'Test Name' },
    // { field: 'time_taken', headerName: 'Time Taken' },
    // { field: 'total_problems', headerName: 'Total Problems' },
    // { field: 'total_score', headerName: 'Total Score' },
    // { field: 'total_solutions', headerName: 'Total Solutions' },
    // { field: 'total_solutions', headerName: 'Total Solutions' },
    // { field: 'total_solutions', headerName: 'Total Solutions' },
    // { field: 'maxscore', headerName: 'Max Score' },
    // {
    //   headerName: 'Percentage Score',
    //   field: 'percentage_score',
    //   resizable: true,
    //   valueGetter: (params) => {
    //     const total = Number(params.data.total_score);
    //     const max = Number(params.data.maxscore);
    //     if (!max || isNaN(total) || isNaN(max)) return '-';
    //     return ((total / max) * 100).toFixed(2) + '%';
    //   },
    //   width: 130,
    // },
    {
      headerName: 'Email Sent',
      field: 'emailSent',
      valueGetter: (params) =>
        params.data?.abCatEvaluation?.emailSent ? 'Yes' : 'No' ?? '-',
      sortable: true,
      filter: true,
      width: 120,
    },
    {
      headerName: 'Cohort Almax',
      field: 'almaXCohort',
      valueGetter: (params) =>
        params.data?.abCatEvaluation?.data?.almaXCohort ?? '-',
      sortable: true,
      filter: true,
      width: 140,
    },

    // {
    //   field: 'viewdetails',
    //   headerName: 'View Details',
    //   width: 200,
    //   cellClass: 'custom-center-cell', // Apply custom styling
    //   cellStyle: { padding: 0, textAlign: 'center' }, // Inline quick fix
    //   cellRenderer: (params) => (
    //     <div className='flex items-center justify-center w-full h-full mr-4'>
    //       <button
    //         onClick={() => {
    //           const path = `/all-almax-students/user-details/${params.data.id}`;
    //           history.push({
    //             pathname: path,
    //             state: {
    //               userParams: params.data,
    //             },
    //           });
    //         }}
    //         className='text-gray-700 hover:text-blue-600'
    //         title='View details'
    //       >
    //         <Visibility style={{ fontSize: 22 }} />
    //       </button>
    //     </div>
    //   ),
    //   sortable: false,
    //   filter: false,
    // },
  ];

  useEffect(() => {
    fetchData();
  }, [courseType, studentId]);

  return (
    <div>
      <div
        className='ag-theme-alpine h-96  w-full'
        style={{ height: '490px' }}
      >
        <AgGridReact
          //   className='ag-theme-alpine'
          //   animateRows='true'
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          //   enableRangeSelection='true'
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          rowHeight={50}
        />
      </div>
    </div>
  );
};

export default AbcatDetails;
